export default "__VITE_ASSET__D6yTabl1__"